/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, useLocation } from 'react-router-dom';
import DefaultLayout from '~/styles/layouts/default';
import PharmacistLayout from '~/styles/layouts/pharmacist';

export default function RouteWrapper({ component: Component, ...rest }) {
  const location = useLocation();
  const Layout =
    location.pathname &&
    (location.pathname.startsWith('/receita') ||
      location.pathname.startsWith('/valida'))
      ? PharmacistLayout
      : DefaultLayout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  component: PropTypes.any,
};

RouteWrapper.defaultProps = {
  component: <div />,
};
